export default __webpack_public_path__ + "static/media/plain-sticker-a.9cc92584.png";